export default __webpack_public_path__ + "static/media/itribe-logo.7eddbd19.svg";